const firebaseConfig = {
  apiKey: 'AIzaSyAuWA8J9JDIZRIUXdIDwWsj4xsL2XZZIm8',
  authDomain: 'upmyranksweb.firebaseapp.com',
  projectId: 'upmyranksweb',
  storageBucket: 'upmyranksweb.appspot.com',
  messagingSenderId: '658970695835',
  appId: '1:658970695835:web:f94d0e4e816dcaa56d4e3e',
  measurementId: 'G-DFR7T4M0YT'
}

export default firebaseConfig
